import { OnboardingDialog } from './onboarding-dialog';
import { useUserContext } from '../../../Contexts/User';
import { V2_ONBOARDING_CUTOFF_DATE } from '@/new/constants/onboarding';

interface SubsetsListOnboardingProps {
  onTakeTour?: () => void;
}

/**
 * Onboarding dialog for the Subsets list page.
 * Only shown to existing users (created before Nov 28, 2025) to explain the V2 changes.
 */
export function SubsetsListOnboarding({ onTakeTour }: SubsetsListOnboardingProps) {
  const { user } = useUserContext();

  // Only show V2 onboarding to existing users (created before cutoff date)
  const userCreatedAt = user?.createdAt ? new Date(user.createdAt) : null;
  const isExistingUser = userCreatedAt && userCreatedAt < V2_ONBOARDING_CUTOFF_DATE;

  if (!isExistingUser) {
    return null;
  }

  return (
    <OnboardingDialog dialogId="subsets-list" icon="lucide--group" title="Subsets" onTakeTour={onTakeTour}>
      <h3 className="text-lg font-medium">Welcome to the Subsets page</h3>
      <p>
        Documents now live at the Matter level, so we created <strong>Subsets</strong> as a way of focusing you analysis
        on a subset of your overall documents.
      </p>
      <p>
        For example, you would have all of your documents in the Matter, and then create a Subset of deposition
        transcripts, or emails, or documents in a certain date range.
      </p>
      <p>
        When viewing data (facts/inconsistencies/entities) within a Subset, you only see the data from the documents in
        that Subset. Using Kim within a Subset will also only reference documents in that Subset.
      </p>
      <p className="text-xs text-gray-500">
        All of your previous Cases have been converted to Subsets, so if you want to continue working within the set of
        documents that you used to work with in your Case, you can do this by going into the Subset and doing your
        analysis in there.
      </p>
    </OnboardingDialog>
  );
}
